export default {
  banner: {
    description: 'Krijg {{range}} korting bij bestellen via de gratis FoodAmigos-app. Klik hier voor de app →',
  },
  labels: {
    deals: 'Aanbiedingen',
    collecting_points: 'Al punten aan het sparen?',
    earn_points: 'Verdien punten & ontvang beloningen ',
    order_again: 'Opnieuw bestellen',
  },
  checkout_button: {
    title: 'Naar winkelwagen',
  },
};
